import { useTranslation } from 'react-i18next'

import { CheckCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

const AllPublishedChip = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Chip
      label={t('Todo publicado')}
      Icon={CheckCircleIcon}
      backgroundColor={theme.colors.success.surface}
      color={theme.colors.success.onSurface}
    />
  )
}

export default AllPublishedChip
